import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CDTo } from '../../../core/store/contract-details/contract-details.interface';
import { RelocationDetail } from '../../../core/store/edit-florder-detail/florder-detail.interface';
import { Place } from '../../../core/interfaces/place.interface';
import { FlorderEditDeliveryComponent } from '../../florder/florder-edit-delivery/florder-edit-delivery.component';
import { appSettings } from '../../../appSettings';

@Component({
  selector: 'app-relocation-edit-delivery',
  templateUrl: './relocation-edit-delivery.component.html',
  styleUrls: ['../../florder/florder-edit-delivery/florder-edit-delivery.component.scss'],
})
export class RelocationEditDeliveryComponent extends FlorderEditDeliveryComponent implements OnInit, OnChanges {

  labelWidth = appSettings.LABEL_WIDTH;

  @Input() locations: Place[];
  @Input() relocationDetail: RelocationDetail;

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.relocationDetail &&
      changes.relocationDetail.previousValue &&
      changes.relocationDetail.previousValue.etmOrderNumber &&
      !changes.relocationDetail.currentValue.etmOrderNumber
    ) {
      this.ngOnInit();
    }
  }

  protected getControlsConfig() {
    return Object.assign(super.getControlsConfig(), {
      type: ['EPS-EPS'],
      shippingCondition: ['Z1'],
    });
  }

  doNextClicked() {
    if (this.deliveryForm.valid && !this.deliveryForm.pending) {
      this.nextClicked.emit(this.deliveryForm.value);
    }
  }

  protected getEtmOrderNumber(): string {
    return this.relocationDetail && this.relocationDetail.etmOrderNumber;
  }

  protected getTo(): CDTo {
    return null; // Not applicable
  }
}
